/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { getCommuneByRegions } from '../../../../modules/sport/actions/reducerListCommune';
import { resetGame, resetGameReset, resetStateGame } from '../../../../modules/sport/actions/reducerListGame';
import { fetchListRegions, resetRegion } from '../../../../modules/sport/actions/reducerListRegion';
import { IFilter } from '../../../interfaces';
import LayoutInside from '../../layout/LayoutInside';

export default function FilterIntegrar(props: { attribute: any; dateList: any }): JSX.Element {
    const { attribute, dateList } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [communes, setCommune] = useState<Array<any>>([]);
    const errorInit = { region: false, commune: false };
    const [error, setError] = useState(errorInit);
    const [msj, setMsj] = useState('');
    const router = useHistory();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const attributeUrl = pathname.length > 1 ? pathname[2] : 'Arrienda';
    const dispatch = useDispatch();
    const [regions, setRegions] = useState<Array<any>>([]);

    const selectListRegions = (state: any) => state.listRegions;
    const listRegions = useSelector(selectListRegions);

    const selectListCommunes = (state: any) => state.listCommunes;
    const listCommunes = useSelector(selectListCommunes);

    const breads = [
        {
            key: 'integrar',
            name: 'Integrar | Buscar',
            url: `/integrar`,
            add: true,
        },
    ];

    const [filter, setFilter] = useState<IFilter>({
        day: null,
        region: '',
        commune: '',
    });

    useEffect(() => {
        dispatch(resetGame());
        dispatch(resetStateGame());
        dispatch(fetchListRegions({ filter: 1, sport: sport, filterOrigin: 'game' }));
    }, []);

    useEffect(() => {
        if (listRegions.data && listRegions.data.length > 0) {
            setRegions(listRegions.data);
        }
    }, [listRegions]);

    useEffect(() => {
        if (listCommunes && listCommunes.data?.data?.length > 0) {
            setCommune(listCommunes.data?.data);
        }
    }, [listCommunes]);

    const handleDate = (e) => {
        e.preventDefault();
        setFilter({ ...filter, day: e.target.value });
    };

    const handleRegion = async (e) => {
        e.preventDefault();
        setLoading(true);
        setFilter({ ...filter, region: e.target.value });
        dispatch(getCommuneByRegions({ id: e.target.value, sport: sport, filter: 1, filterOrigin: 'game' }));
        setLoading(false);
    };

    const handleCommune = (e) => {
        e.preventDefault();
        setFilter({ ...filter, commune: e.target.value });
    };

    const handleNext = () => {
        setError(errorInit);
        if (filter?.region === '') {
            setError({ ...error, region: true });
        } else {
            setMsj('Valido');
            dispatch(resetGameReset());
            dispatch(resetGame());
            const path = `/${sport}/${attributeUrl}/partidos/filter`;
            if (path) {
                const search = `?day=${filter.day ? filter.day : ''}&region=${
                    filter.region ? filter.region : ''
                }&commune=${filter.commune ? filter.commune : ''}`;
                router.push({
                    pathname: path,
                    search: search,
                });
            }
        }
    };

    useEffect(() => {
        dispatch(resetGame());
        dispatch(resetStateGame());
        setRegions([]);
        setCommune([]);
        dispatch(resetRegion());
        dispatch(fetchListRegions({ filter: 1, sport: sport, filterOrigin: 'game' }));
    }, [sport]);

    return (
        <>
            <LayoutInside attribute={attribute} title={attribute?.filter?.title} subTitle={''} breads={breads}>
                <>
                    {/** Filter */}
                    <div className={`flex-col pt-8 md:pt-16`}>
                        <div className="container mx-auto w-full flex justify-center  items-center ">
                            <div
                                className={`grid  w-full  sm:w-3/4 grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 text-center justify-center items-center`}
                            >
                                <div className="flex-col flex justify-end  items-end px-2 pt-4 md:pt-0">
                                    <div className="flex w-full md:w-60 lg:w-60 h-14  justify-center content-center">
                                        <select
                                            className={`${
                                                error.region
                                                    ? 'border-red-600 shadow-error'
                                                    : filter.region
                                                    ? regions && regions.length > 0
                                                        ? 'border-green-600 shadow-success'
                                                        : 'border-sm-gray-1'
                                                    : 'border-sm-gray-1'
                                            } w-full md:w-60 lg:w-60  h-14 bg-white border-2  rounded-xl text-center`}
                                            name="region"
                                            onChange={handleRegion}
                                            disabled={regions && regions.length > 0 ? false : true}
                                        >
                                            <option className="text-sm-gray-1" value="">
                                                Región *
                                            </option>
                                            {regions &&
                                                regions.length > 0 &&
                                                regions.map((r, i) => (
                                                    <option value={r.id} key={`region-${i}`}>
                                                        {r.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="flex-col  flex justify-center  items-center px-2 pt-4 md:pt-0">
                                    <div className="flex w-full md:w-60 h-14 justify-center content-center ">
                                        {!loading ? (
                                            <select
                                                className={`${
                                                    error.commune
                                                        ? 'border-red-600 shadow-error'
                                                        : filter.commune
                                                        ? 'border-green-600 shadow-success'
                                                        : 'border-sm-gray-1'
                                                } w-full md:w-60 lg:w-60  h-14 bg-white border-2  rounded-xl text-center`}
                                                name="commune"
                                                onChange={handleCommune}
                                                disabled={communes && communes.length > 0 ? false : true}
                                            >
                                                <option className="text-sm-gray-1" value="">
                                                    Comuna
                                                </option>
                                                {communes &&
                                                    communes.length > 0 &&
                                                    communes.map((commune) => (
                                                        <option value={commune.id} key={`commune-${commune.id}`}>
                                                            {commune.name}
                                                        </option>
                                                    ))}
                                            </select>
                                        ) : (
                                            <div className="border border-sm-rent shadow rounded-xl p-4 max-w-sm w-full mx-auto">
                                                <div className="animate-pulse flex space-x-4">
                                                    <div className="rounded-full bg-sm-rent-dark h-6 w-12"></div>
                                                    <p className="pl-1 animate-pulse text-sm-rent-dark">Comuna</p>
                                                    <div className="flex-1 space-y-4 py-1">
                                                        <div className="h-4 bg-sm-rent-dark rounded w-3/4"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex-col   flex justify-start  items-start px-2 pt-4 md:pt-0">
                                    <div className="flex w-full md:w-60 h-14  justify-center content-center ">
                                        <select
                                            className={`${
                                                filter.day ? 'border-green-600 shadow-success' : 'border-sm-gray-1'
                                            } w-full md:w-60 lg:w-60  h-14 bg-white border-2  rounded-xl text-center`}
                                            name="day"
                                            onChange={handleDate}
                                            disabled={dateList && dateList.length > 0 ? false : true}
                                        >
                                            <option className="text-sm-gray-1" value="">
                                                Día
                                            </option>
                                            {dateList &&
                                                dateList.length > 0 &&
                                                dateList.map((d) => (
                                                    <option value={d.id} key={d.id}>
                                                        {d.date} {d.day}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/**Button Next */}
                    <div className={`flex-col`}>
                        <div className={`pt-8 md:pt-16 pb-20 text-center`}>
                            <button
                                className={`${attribute?.filter?.btColor} w-1/2  md:w-1/4 lg:w-1/4 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                type="button"
                                onClick={() => handleNext()}
                            >
                                {attribute?.filter?.btName}
                            </button>
                            <p className={`text-sm-rent-dark text-xs uppercase py-4 font-extrabold`}>{msj}</p>
                        </div>
                    </div>
                </>
            </LayoutInside>
        </>
    );
}
